import React from 'react';
import Routes from './Route_temp';
import useDeviceRotateAlert from "./hooks/useDeviceRotateAlert";
import useMaintenance from "./Utilities/useMaintenance";
import MaintenancePage from "./Utilities/MaintenancePage";

function App() {
    useDeviceRotateAlert()
    const maintenance = useMaintenance();

    if (maintenance) {
        return <MaintenancePage />;
    }

    return <Routes />;
}

export default App;